var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstHorizontalOffsetLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 300,
    viewBox: "0 0 641 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.394 83.6793V84.3012H303.162V82.2412",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0523 82.2412H306.866L315.882 76.638C315.882 76.638 315.809 75.2365 313.5 75.1296C311.192 75.0226 62.9001 75.1296 62.9001 75.1296C62.9001 75.1296 59.2921 75.3097 63.8381 77.2853C68.384 79.2609 78.0523 82.2412 78.0523 82.2412Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.019 82.2412V83.6793H302.394V82.2412",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.019 83.6793V84.183H81.2251V82.2412",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 62.1221L24.6707 69.1633L33.2794 125.353H36.2121C35.4917 73.1877 73.868 69.1633 73.868 69.1633H313.359H320.501",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 65.1416C0 65.2148 25.1425 72.242 25.1425 72.242L17.7458 73.6181L40.1082 216.751L0 236.44",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 233.567L19.0427 224.37L0 101.499",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 85.2607L10.821 87.2729L29.8636 221.78",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92468 86.3613L26.4478 223.458",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.5186L14.282 84.1827L34.2033 219.65",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92472 87.5603L1.87604 86.7441L22.6873 225.304L19.0427 224.37",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.499 56.3022C320.499 56.3022 76.1735 56.3022 59.7273 56.3022C43.2811 56.3022 34.2005 69.1634 34.2005 69.1634H24.6707",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1425 72.2421H39.676C39.676 72.2421 47.9005 62.4569 60.6427 62.122C73.3877 61.7871 89.3055 62.122 89.3055 62.122L91.3256 64.3256L88.6331 65.8593L73.868 69.1633",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2816 65.1417L8.43921 26.772L12.2816 18.3659C12.2816 18.3659 26.8349 18.2589 29.8636 5.21764V0",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.086 195.985H302.394H338.606",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.23 195.985H300.086",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2041 101.499L51.0733 195.985H52.6583",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.948 82.2412H334.134L325.118 76.638C325.118 76.638 325.191 75.2365 327.5 75.1296C329.808 75.0226 578.1 75.1296 578.1 75.1296C578.1 75.1296 581.708 75.3097 577.162 77.2853C572.613 79.2609 562.948 82.2412 562.948 82.2412Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.981 82.2412V83.6793H338.606V82.2412",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.981 83.6793V84.183H559.775V82.2412",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 62.1221L616.329 69.1633L607.721 125.353H604.788C605.508 73.1877 567.132 69.1633 567.132 69.1633H327.641H320.499",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 65.1416C641 65.2148 615.857 72.242 615.857 72.242L623.254 73.6181L600.892 216.751",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 233.567L621.955 224.37L641 101.499",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 85.2607L630.179 87.2729L599.892 301.199",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.075 86.3613L603.093 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 80.5186L626.715 84.1827L594.981 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.075 87.5603L639.124 86.7441L618.313 225.304L621.955 224.37",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.499 56.3022C320.499 56.3022 564.824 56.3022 581.27 56.3022C597.716 56.3022 606.797 69.1634 606.797 69.1634H616.329",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.857 72.2421H601.324C601.324 72.2421 593.099 62.4569 580.357 62.122C567.612 61.7871 551.694 62.122 551.694 62.122L549.674 64.3256L552.367 65.8593L567.132 69.1633",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.718 65.1417L632.561 26.772L628.718 18.3659C628.718 18.3659 614.165 18.2589 611.136 5.21764V0",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.796 101.499L589.927 195.985H338.606",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.923 199.219H381.743L405.114 208.056H575.066C575.066 208.056 592.15 208.044 600.889 216.749",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.313 225.304L641 236.44",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 248.153L616.762 235.433L607.24 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.46 0V32.5694C205.46 32.5694 201.835 43.4409 224.053 43.4409C246.272 43.4409 320.499 43.4409 320.499 43.4409",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.54 0V32.5694C435.54 32.5694 439.165 43.4409 416.947 43.4409C394.728 43.4409 320.501 43.4409 320.501 43.4409",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.053 43.4409C246.272 43.4409 320.499 43.4409 320.499 43.4409",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.585 83.6792L269.499 143.462L264.306 136.852L184.957 83.6792H172.585Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.199 83.6792L362.285 143.462L367.478 136.852L446.827 83.6792H459.199Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 242.333C0 242.333 59.8713 208.706 101.712 229.399L105.656 227.004C105.656 227.004 109.43 226.405 110.656 228.49C111.883 230.575 104.74 250.095 104.74 250.095L94.2075 284.871L64.923 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 248.654C0 248.654 50.9292 216.608 101.712 233.564L89.8819 270.786C89.8819 270.786 89.5937 273.302 83.6775 276.102C77.7613 278.905 27.8435 300 27.8435 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.711 229.399C101.711 229.399 107.218 231.459 105.415 236.297C103.613 241.134 92.9106 273.518 92.9106 273.518C92.9106 273.518 91.9359 275.333 89.0145 277.039C86.0931 278.744 40.1054 300.391 40.1054 300.391",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5589 251.952L76.7357 231.49C77.4618 231.251 78.2274 231.74 78.3094 232.497L79.8181 246.194C79.9085 247.022 79.4282 247.807 78.6456 248.102L15.3415 271.987C14.1803 272.426 12.9371 271.57 12.9371 270.332V254.19C12.9371 253.174 13.5898 252.273 14.5589 251.952Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7357 231.493C76.7357 231.493 78.7727 230.322 79.2784 233.879C79.7842 237.436 81.0104 246.932 81.0104 246.932C81.0104 246.932 81.324 248.992 79.8322 249.661C78.3404 250.331 15.7285 273.158 15.7285 273.158C15.7285 273.158 13.3948 273.684 12.9399 270.667",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4261 253.205L25.3912 249.47V266.691L14.4261 270.881V253.205Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.931 249.088V265.469C26.931 265.469 36.9326 261.853 36.9326 261.732C36.9326 261.611 36.6924 246.164 36.6924 246.164L26.931 249.088Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2322 245.589V261.158L47.9937 257.707L47.4174 242.477L38.2322 245.589Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.813 241.948L49.4374 257.42L58.8147 253.782L57.9982 238.979L48.813 241.948Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2469 238.979L59.9702 253.492L68.8163 250.236L67.9037 235.723L59.2469 238.979Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94493 279.839L7.21301 283.576L82.6688 255.121V251.767L8.94493 279.839Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6688 255.121L84.3979 267.67L7.21301 300V283.576",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6688 251.766L85.4094 250.666L87.2854 265.469C87.2854 265.469 87.8618 268.081 84.9771 269.446C82.0925 270.81 12.9371 300.388 12.9371 300.388",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9318 229.073L44.9395 200.944C44.9395 200.944 46.7082 198.141 50.8558 196.633C55.0033 195.124 96.8068 185.854 96.8068 185.854H168.655",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8269 300C98.8269 300 90.8906 223.649 161.224 188.874H126.6C126.6 188.874 61.1371 197.927 55.4017 199.652C49.6663 201.377 47.9966 204.825 47.9966 204.825L40.1111 226.768",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.224 188.874C161.224 188.874 225.353 158.798 264.738 229.399C264.738 229.399 282.772 259.374 276.279 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.677 275.528C112.677 275.528 116.643 245.708 125.083 234.285C125.083 234.285 130.925 225.769 139.438 232.346L141.492 233.696L151.773 240.465C151.773 240.465 154.658 243.915 150.979 250.453C147.301 256.99 127.608 277.039 127.608 277.039L121.116 280.703C121.116 280.703 112.928 284.151 112.677 275.528Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.512 233.052C140.384 232.967 139.582 230.429 141.772 228.777C143.959 227.125 151.677 222.268 151.677 222.268C151.677 222.268 153.336 221.207 155.766 221.544C158.195 221.882 166.538 223.365 166.538 223.365C154.133 221.257 152.16 222.839 152.16 222.839C152.16 222.839 144.778 227.702 142.783 229.45C140.789 231.197 141.495 233.699 141.495 233.699",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.392 231.014C137.392 231.014 126.142 223.937 120.469 235.528C114.793 247.12 109.023 273.755 109.023 273.755C109.023 273.755 105.947 284.39 117.008 282.952C117.008 282.952 123.882 280.892 127.611 277.036C127.611 277.036 127.498 291.982 132.765 297.946",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.877 274.7C129.877 274.7 128.36 288.532 132.762 293.131L134.748 295.357",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.493 300L144.343 287.167C144.343 287.167 148.852 283.647 153.576 286.306C158.3 288.966 169.302 300 169.302 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.712 300L130.391 293.947",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.188 292.435L143.408 282.642C143.408 282.642 148.962 277.357 155.311 281.384C161.659 285.408 177.961 300 177.961 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.391 277.683C130.391 277.683 156.859 255.445 156.966 255.265C157.074 255.085 168.796 245.961 158.986 237.301",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39 300C207.39 300 212.295 283.596 227.156 292.658L233.863 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06 300C210.06 300 213.812 294.355 218.861 294.355C223.909 294.355 231.413 300 231.413 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 300C240.5 300 240.426 287.888 240.212 282.642C239.997 277.396 236.024 272.316 236.024 272.316L253.485 286.16C253.485 286.16 258.644 292.055 262.647 285.805C266.651 279.555 264.45 249.729 253.053 229.072C241.655 208.418 229.826 201.521 229.826 201.521C229.826 201.521 204.723 185.713 179.187 191.893C153.652 198.073 147.448 207.464 147.448 207.464C147.448 207.464 144.888 211.328 147.88 213.735C150.875 216.141 163.397 222.875 163.397 222.875",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.401 221.477C153.186 221.674 143.261 215.17 143.261 215.17C143.261 215.17 137.958 212.043 143.91 206.62C149.861 201.194 166.635 190.382 184.669 188.873C202.703 187.365 217.705 193.903 217.705 193.903C217.705 193.903 233.852 198.721 245.543 217.292",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.538 223.362L197.51 233.696L213.668 246.068L235.454 270.138C235.442 270.234 235.683 271.117 236.027 272.316C236.849 275.178 238.265 279.839 238.265 279.839C238.265 279.839 238.804 281.384 238.553 287.097C238.302 292.81 237.759 300 237.759 300C237.759 300 233.213 292.63 220.157 281.384C207.102 270.138 201.835 283.576 201.835 283.576C201.835 283.576 193.684 298.88 193.467 300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.211 282.642L256.946 294.963C256.946 294.963 261.492 298.714 265.314 293.947C269.137 289.179 270.219 253.326 261.998 238.019",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.02 244.807L222.177 245.229C222.177 245.229 228.368 247.132 229.176 253.461C229.21 253.72 229.232 253.987 229.246 254.26C229.608 261.231 230.173 264.307 230.173 264.307",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.176 253.461L232.781 252.63L234.442 259.072L229.707 260.589",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.422 251.409L232.784 252.631L234.442 259.073L234.804 260.39C234.804 260.39 242.992 255.622 243.028 252.318C243.025 252.318 242.952 250.5 232.422 251.409Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.422 251.409L246.416 247.65L246.97 248.176L247.136 247.433L259.398 244.081",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.656 248.75L249.278 255.673",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.424 248.536L250.046 255.386",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.801 260.392L249.47 256.224L249.902 255.673L250.671 255.96L261.865 253.148",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.645 246.715C146.645 246.715 139.726 243.805 136.915 246.211C134.101 248.617 143.769 253.613 143.769 253.613L146.645 246.715Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.584 249.287L146.645 246.715L146.996 246.175L127.679 237.805L123.424 246.285L143.766 254.33V253.613L147.436 255.358",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.176 235.613L127.778 237.301L128.227 238.041",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.565 245.606L123.424 246.884L124.178 246.583",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.694 225.225L128.227 194.046L152.367 193.708",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.251 194.412L214.843 194.649",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.722 197.215L266.275 198.932C266.275 198.932 269.931 198.932 269.835 203.721C269.739 208.511 266.976 233.693 266.976 233.693",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.053 189.065L297.633 191.603L301.744 202.883V206.55",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.365 203.986L284.541 203.316C284.541 203.316 288.058 206.136 284.541 210.898L282.995 209.511",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.541 209.817C286.903 206.207 284.36 204.141 284.36 204.141L280.464 203.53L279.887 208.883L284.541 209.817Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.464 203.53C280.464 203.53 283.368 207.194 279.887 208.883",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.541 203.316L309.392 208.022C309.392 208.022 313.322 210.194 309.969 216.358L290.833 212.249L284.541 210.898",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.833 212.246L289.7 214.357C289.7 214.357 289.539 215.043 290.632 215.862C290.997 216.135 291.502 216.422 292.2 216.704C294.989 217.83 297.094 217.506 297.094 217.506L299.238 214.053",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.629 215.862L289.324 217.739L288.759 218.55C288.759 218.55 288.615 221.62 292.98 221.64L295.362 217.5",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.358 213.127L287.496 212.944C287.496 212.944 286.592 212.98 286.239 214.247C286.16 214.525 286.109 214.866 286.1 215.277C286.052 217.559 285.835 238.089 285.835 238.089C285.835 238.089 285.798 239.851 286.88 240.028C287.962 240.208 291.785 240.856 291.785 240.856C291.785 240.856 292.706 241.106 293.048 239.671L293.409 233.744V228.943",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.242 214.247C286.242 214.247 290.499 225.15 285.888 238.672",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.98 221.637C292.98 221.637 294.494 233.08 291.791 240.859",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.887 206.206C279.887 206.206 278.085 205.829 278.085 207.985C278.085 210.141 276.57 241.252 276.57 241.252C276.57 241.252 275.813 244.306 279.023 244.846C282.232 245.384 297.274 249.085 297.274 249.085C297.274 249.085 298.967 249.839 299.238 248.367C299.509 246.895 298.998 214.435 298.998 214.435",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.422 214.247L301.142 254.451C301.142 254.451 301.43 256.824 299.026 256.272C296.622 255.721 275.319 251.1 275.319 251.1C275.319 251.1 273.084 250.978 273.443 247.554L276.491 204.107C276.491 204.107 276.017 201.495 278.927 201.616C281.837 201.737 298.501 202.525 298.501 202.525C298.501 202.525 300.377 202.286 300.425 205.064V206.206",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.177 214.897L303.812 255.287C303.812 255.287 303.727 257.539 300.495 257.851C297.263 258.163 275.596 260.389 275.596 260.389",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.812 255.29C303.812 255.29 303.739 265.039 303.812 265.852C303.886 266.665 302.538 267.194 302.538 267.194L281.6 268.489C281.6 268.489 280.464 268.68 280.464 270.118C280.464 271.556 280.176 282.428 280.176 282.428C280.176 282.428 280.08 284.367 281.859 284.871C283.639 285.374 338.606 300.003 338.606 300.003",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.032 269.204L301.154 286.236L353.608 300L352.744 282.425L302.032 269.204Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.923 199.219H300.408",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 249.279C303.716 249.279 404.391 267.769 404.391 267.192C404.391 266.615 405.111 208.056 405.111 208.056",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.743 199.219L370.49 224.44H303.309",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.49 224.44L404.394 267.194V300",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.677 246.645L400.065 265.039L370.49 226.43C370.49 226.43 369.312 225.495 366.497 225.425C363.683 225.352 303.34 225.425 303.34 225.425",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.848 201.04L372.651 222.98C372.651 222.98 371.159 224.08 372.651 225.757C374.143 227.434 404.416 265.036 404.416 265.036",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.958 218.75L158.701 203.53C158.701 203.53 186.352 200.727 197.51 201.422C208.667 202.117 236.123 206.547 236.123 206.547L238.194 240.892",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.191 208.582L240.212 238.379C240.212 238.379 240.825 241.65 236.748 240.895C232.671 240.141 206.641 235.562 199.764 235.427",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.709 218.035C154.621 217.984 157.401 203.533 157.401 203.533C157.401 203.533 157.582 202.455 159.566 202.168C161.549 201.881 182.612 198.541 196.139 199.438C209.664 200.336 234.143 204.769 234.143 204.769",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.101 222.284C185.138 222.535 184.663 229.41 184.663 229.41L207.534 231.051V223.362L185.101 222.284Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.089 228.552L182.863 221.854C182.863 221.854 182.79 219.662 186.18 219.915C189.57 220.168 206.305 221.105 206.305 221.105C206.305 221.105 209.37 221.1 209.551 223.365C209.732 225.631 209.226 236.418 209.226 236.418",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.906 223.25C163.693 216.768 165.877 209.719 172.226 206.606C178.108 203.721 185.722 205.143 188.618 211.421C189.83 214.05 190.082 217.036 189.935 219.892",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.979 220.917C202.773 217.728 203.409 214.371 205.146 211.65C209.658 204.58 220.123 205.928 225.172 211.582C226.184 212.716 227.012 214.022 227.546 215.446C228.582 218.195 228.715 221.224 228.136 224.089C227.896 225.276 227.56 226.444 227.156 227.587C227.156 227.587 222.081 235.934 209.362 233.347",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.588 217.039L166.849 221.102L176.588 218.035V217.039Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.738 218.404L204.867 216.034L213.738 219.555V218.404Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.375 219.892C169.412 219.552 167.68 210.298 178.102 209.465C178.102 209.465 186.796 209.024 185.316 219.892",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.889 225.225C227.37 218.142 221.095 213.087 221.095 213.087C211.43 206.8 207.534 216.746 207.534 216.746",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.585 224.01C209.585 224.01 212.218 219.38 217.598 221.483C222.98 223.585 223.172 229.087 223.09 231.4",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.74 224.432C169.74 224.432 172.441 217.708 180.27 220.34C180.27 220.34 182.92 221.406 182.691 223.365",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 70,
    x2: 320,
    y2: 195.5,
    stroke: "#2D9DC9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.462 143.976C169.297 142.885 170.058 142.006 171.163 142.013L215.876 142.29C216.981 142.297 218.01 143.187 218.175 144.279L222.8 174.824C222.965 175.915 222.204 176.794 221.099 176.787L176.386 176.51C175.281 176.503 174.252 175.613 174.087 174.521L169.462 143.976ZM197.895 172.053L199.087 172.058C199.383 172.059 199.563 171.76 199.489 171.389L198.388 165.886C198.314 165.515 198.014 165.213 197.717 165.212L196.526 165.207C196.23 165.205 196.049 165.505 196.123 165.876L197.224 171.379C197.298 171.749 197.599 172.051 197.895 172.053ZM197.109 154.791L195.918 154.785C195.622 154.784 195.322 154.482 195.246 154.105L194.145 148.601C194.071 148.231 194.252 147.931 194.548 147.932L195.739 147.938C196.035 147.939 196.336 148.241 196.41 148.612L197.512 154.122C197.586 154.493 197.406 154.792 197.109 154.791ZM185.806 161.347L191.074 161.367C191.429 161.368 191.646 161.066 191.559 160.691L191.21 159.188C191.123 158.814 190.765 158.509 190.41 158.508L185.142 158.488C184.787 158.487 184.57 158.79 184.657 159.164L185.006 160.667C185.092 161.041 185.451 161.346 185.806 161.347ZM202.426 160.802L202.077 159.299C201.99 158.925 202.207 158.622 202.562 158.623L207.83 158.643C208.185 158.644 208.544 158.949 208.63 159.323L208.979 160.826C209.066 161.2 208.849 161.503 208.494 161.502L203.226 161.482C202.871 161.481 202.513 161.176 202.426 160.802ZM189.125 167.942L190.309 169.005C190.606 169.272 190.99 169.274 191.164 169.008L193.804 165.116C193.984 164.851 193.89 164.423 193.593 164.163L192.41 163.1C192.112 162.833 191.728 162.831 191.554 163.097L188.914 166.988C188.739 167.247 188.833 167.675 189.125 167.942ZM202.088 156.894C201.914 157.16 201.531 157.158 201.233 156.891L200.049 155.828C199.752 155.568 199.658 155.14 199.838 154.875L202.478 150.983C202.652 150.717 203.036 150.719 203.334 150.986L204.518 152.049C204.814 152.309 204.909 152.737 204.729 153.003L202.088 156.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.414 160.414C317.195 159.633 317.195 158.367 316.414 157.586L303.686 144.858C302.905 144.077 301.639 144.077 300.858 144.858C300.077 145.639 300.077 146.905 300.858 147.686L312.172 159L300.858 170.314C300.077 171.095 300.077 172.361 300.858 173.142C301.639 173.923 302.905 173.923 303.686 173.142L316.414 160.414ZM221.586 157.586C220.805 158.367 220.805 159.633 221.586 160.414L234.314 173.142C235.095 173.923 236.361 173.923 237.142 173.142C237.923 172.361 237.923 171.095 237.142 170.314L225.828 159L237.142 147.686C237.923 146.905 237.923 145.639 237.142 144.858C236.361 144.077 235.095 144.077 234.314 144.858L221.586 157.586ZM315 157H223V161H315V157Z",
    fill: "#2D9DC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 641,
    height: 300,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstHorizontalOffsetLeft);
export default __webpack_public_path__ + "static/media/instHorizontalOffsetLeft.40bf682777e7926823c1f4166c19f70c.svg";
export { ForwardRef as ReactComponent };